import React from 'react'



function PageNotFound() {

  return (
    <div className='text-white text-4xl h-[90vh] flex items-center justify-center'>
        ERROR - 404 : PAGE NOT FOUND 
    </div>
  )
}

export default PageNotFound;
